import React, { useMemo } from 'react';
import { MenuItem } from '@material-ui/core';
import InlineTextField from './InlineTextField';
import { useField, useFormikContext } from 'formik';
export const InlineSelectField = props => {
    let { name, options, children } = props;
    const formik = useFormikContext();
    const [field, meta, { setTouched }] = useField(name);
    return useMemo(() => (React.createElement(InlineTextField, Object.assign({ select: true, disableFocusControls: true }, props, { onChange: event => {
            setTouched(true);
            field.onChange(event);
            formik.submitForm();
        } }),
        options &&
            options.map(option => typeof option === 'string' ? (React.createElement(MenuItem, { key: option, value: option }, option)) : (React.createElement(MenuItem, { key: option.value.toString(), value: option.value }, option.label))),
        children)), [children, field, formik, options, props, setTouched]);
};
export default InlineSelectField;
//# sourceMappingURL=InlineSelectField.js.map